import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="font-serif text-3xl md:text-4xl font-semibold tracking-tight">
             
               <img src="/images/logos/brandingyard_logo_white.png" className="h-40" alt="Branding Yard" />
            </Link>
            <p className="mt-6 text-[#A3A3A3] leading-relaxed max-w-md">
              Elevating corporate identity through premium branding products. 
              We craft sophisticated solutions for businesses that demand excellence.
            </p>
            <div className="flex gap-4 mt-8">
              <a 
                href="https://www.facebook.com/share/1C8zWXjoSK/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0A0A0A] transition-colors"
                data-testid="facebook-link"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#0A0A0A] transition-colors opacity-50 cursor-not-allowed"
                data-testid="instagram-link"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm uppercase tracking-wider font-medium mb-6">Quick Links</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/store" className="text-[#A3A3A3] hover:text-white transition-colors">
                  Shop All
                </Link>
              </li>
              <li>
                <Link to="/store?category=corporate-gifts" className="text-[#A3A3A3] hover:text-white transition-colors">
                  Corporate Gifts
                </Link>
              </li>
              <li>
                <Link to="/store?category=corporate-apparel" className="text-[#A3A3A3] hover:text-white transition-colors">
                  Corporate Apparel
                </Link>
              </li>
              <li>
                <Link to="/store?category=promotional-items" className="text-[#A3A3A3] hover:text-white transition-colors">
                  Promotional Items
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#A3A3A3] hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm uppercase tracking-wider font-medium mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#A3A3A3]" />
                <a href="mailto:info@brandingyard.co.zw" className="text-[#A3A3A3] hover:text-white transition-colors">
                  info@brandingyard.co.zw
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#A3A3A3]" />
                <a href="tel:+263771234567" className="text-[#A3A3A3] hover:text-white transition-colors">
                  +263 77 123 4567
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#A3A3A3]" />
                <span className="text-[#A3A3A3]">
                  Harare, Zimbabwe
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#737373] text-sm">
            © {currentYear} Branding Yard. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-[#737373]">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>

        {/* Developer Signature */}
        <div className="mt-2 text-center">
          <a 
            href="https://absp.online" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#525252] text-xs hover:text-[#737373] transition-colors"
          >
            Developed by ABSP
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
